export const isFullStatic = false
export const staticPath = "/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"